export default "__VITE_ASSET__DhdoML1d__"